import { useEffect, useState } from "react";
import { FormControl, Text, Textarea, TextInput } from "@primer/react";
import { Alert } from "../components/Alert/Alert.jsx";
import { Button } from "../components/Button/Button.jsx";
import { FormBody, FormContainer, FormFooter } from "../components/FormContainer/FormContainer.jsx";
import { PageHeading } from "../components/PageHeading/PageHeading.jsx";
import { createShareToken, validShareToken } from "../lib/shareToken.js";
import "./ShareTestPage.css";

export function ShareTestPage({ fetchRequest = fetch }) {
  const routeToken = window.location.hash.replace(/^#\/share-test\/?/, "");
  const [token, setToken] = useState(routeToken);
  const [value, setValue] = useState("");
  const [status, setStatus] = useState(null);
  const [working, setWorking] = useState(false);

  useEffect(() => {
    if (!routeToken) createShareToken().then((created) => {
      setToken(created);
      window.history.replaceState(null, "", `#/share-test/${created}`);
    });
  }, [routeToken]);

  async function request(method) {
    setWorking(true);
    setStatus(null);
    try {
      if (!await validShareToken(token)) throw new Error("This sharing token is invalid.");
      const response = await fetchRequest("/api/share-test", { method, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, body: method === "PUT" ? JSON.stringify({ value }) : undefined });
      const result = await response.json();
      if (!response.ok) throw new Error(result.error ?? `Request failed (${response.status}).`);
      if (method === "GET") setValue(result.value);
      setStatus({ tone: "success", text: `${method === "GET" ? "Loaded" : "Saved"} ${new Date(result.updatedAt).toLocaleString()}.` });
    } catch (error) {
      setStatus({ tone: "danger", text: error.message });
    } finally {
      setWorking(false);
    }
  }

  async function copyLink() {
    const origin = window.location.hostname === "localhost" ? "https://regulator.dannyb.co" : window.location.origin;
    await navigator.clipboard.writeText(`${origin}/#/share-test/${token}`);
    setStatus({ tone: "success", text: "Sharing link copied." });
  }

  return <article className="share-test-page narrow-page">
    <PageHeading description="Isolated Cloudflare KV connectivity experiment.">Share test</PageHeading>
    <Alert tone="warning" heading="Development tool">This page stores only the text below. It is not connected to any Regulator profile.</Alert>
    <FormContainer>
      <FormBody>
        <FormControl><FormControl.Label>Sharing token</FormControl.Label><TextInput value={token} readOnly block /></FormControl>
        <FormControl><FormControl.Label>Shared text</FormControl.Label><Textarea aria-label="Shared text" value={value} onChange={(event) => setValue(event.target.value)} resize="vertical" rows={5} block /></FormControl>
      </FormBody>
      <FormFooter><div><Button onClick={() => request("PUT")} disabled={!token || working}>{working ? "Working…" : "Save"}</Button><Button tone="secondary" onClick={() => request("GET")} disabled={!token || working}>Load</Button><Button tone="quiet" onClick={copyLink} disabled={!token}>Copy link</Button></div><Text className={`share-test-status ${status?.tone ?? ""}`} role={status?.tone === "danger" ? "alert" : "status"}>{status?.text}</Text></FormFooter>
    </FormContainer>
  </article>;
}
